import {Action, Module, Mutation, VuexModule} from 'vuex-module-decorators'
import {SearchTypes}                          from "@/util/enums/SearchTypes";
import search                                 from "@/api/search";

@Module
export default class Infrastructure extends VuexModule {
    private _searchQuery                  = "";
    private _searchType                   = SearchTypes.Batch;
    private _searchResults: object | null = null;
    private _searchLoadingStatus          = '';

    get searchResults() {
        return this._searchResults;
    }

    get searchQuery() {
        return this._searchQuery;
    }


    get searchType() {
        return this._searchType;
    }

    @Mutation
    setSearchResults(results: object): void {
        this._searchResults = results;
    }

    @Mutation
    setSearchLoadingStatus(status: string): void {
        this._searchLoadingStatus = status;
    }

    @Mutation
    setSearchQuery(query: string): void {
        this._searchQuery = query;
    }

    @Mutation
    setSearchType(type: SearchTypes): void {
        this._searchType = type;
    }

    @Action
    async loadSearchResults() {
        if (this._searchLoadingStatus !== 'loading' && this.searchQuery.length > 3) {
            this.context.commit('setSearchLoadingStatus', 'loading');
            await search.getResults(this._searchQuery, this._searchType).then((response) => {
                this.context.commit('setSearchLoadingStatus', 'success');
                this.context.commit('setSearchResults', response.data);
            }).catch(() => {
                this.context.commit('setSearchLoadingStatus', 'fail');
                this.context.dispatch('clearSearchResults');
            })
        } else {
            await this.context.dispatch('clearSearchResults');
        }
    }

    @Action({'commit': 'setSearchResults'})
    clearSearchResults() {
        return null;
    }
    @Action
    changeSearchType(type: SearchTypes) {
        this.context.commit('setSearchType', type);
        this.context.dispatch('loadSearchResults').then();
    }
}